const formatProviderName = (providerKey = '') => {
    if (!providerKey) return '';

    return providerKey
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const calendarIntegrationUtils = {
    formatProviderName,
};
